import { useNavigate } from "react-router-dom";
import { PiCertificateFill } from "react-icons/pi";
import { useState } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import RoleService from "../../Services/RoleService";
import AccountDetailsIcon from "./Icons/AccountDetailsIcon";
import CompanyDetailsIcon from "./Icons/CompanyDetailsIcons";
import ConsentManagmentIcon from "./Icons/ConsentManagmentIcon";
import ConsentSharingIcon from "./Icons/ConsentSharingIcon";
import DashboardIcon from "./Icons/DashboardIcon";
import EventIcons from "./Icons/EventIcon";
import { TbPhoneCall, TbUserCheck } from "react-icons/tb";
import { FaUserAlt } from "react-icons/fa";
import { BsFillCalendar2EventFill } from "react-icons/bs";
import { GrIntegration } from "react-icons/gr";


const VerticalMenu = () => {
  let navigate = useNavigate();

  const isAdmin = RoleService.isAdmin();
  const isClient = RoleService.isClient();
  const hasAnyRole = RoleService.hasAnyRole(["admin_user", "client"]);

  let user_type = localStorage.getItem("user_type");
  let is_super_admin = localStorage.getItem("is_super_admin");

  let url = window.location.href;
  const partAfterAdmin = url.split("/admin/")[1];
  const [activeItem, setActiveItem] = useState(partAfterAdmin);
  const handleItemClick = (href: any) => {
    setActiveItem(href);
    navigate(href);
  };

  return (
    <>
      <div id="vertical_menu" className="verticle-menu">
        <div className="menu-list mt-2" style={{ marginRight: "8px" }}>
          {isAdmin && (
            <>
              {/* <Dropdown drop="end" className="font-14 text-start ">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "dashboard" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("dashboard")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <DashboardIcon
                      fillColor={
                        activeItem === "dashboard" ? "#ffffff" : "#000000"
                      }
                    />
                    <span className="text-nowrap">Dashboard</span>
                  </div>
                </Dropdown.Item>
              </Dropdown> */}

              <Dropdown drop="end" className="font-14 text-start ">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "dashboard" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("dashboard")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <DashboardIcon
                      fillColor={
                        activeItem === "dashboard" ? "#ffffff" : "#000000"
                      }
                    />
                    <span className="text-nowrap">Dashboard</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
              {
                user_type === "ADMIN_USER" && is_super_admin === "1"
                  ?
                  <Dropdown drop="end" className=" font-14">
                    <Dropdown.Item
                      className={`menu-item ${activeItem === "white-label-partners" ? "active" : ""
                        }`}
                      onClick={() => handleItemClick("white-label-partners")}
                    >
                      <div className="d-flex justify-content-center">
                        <FaUserAlt className="me-2" size={18} />
                        <span className="">White Label Partners</span>
                      </div>
                    </Dropdown.Item>
                  </Dropdown>
                  :
                  null
              }


              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "clients" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("clients")}
                >
                  <div className="d-flex justify-content-center">
                    <FaUserAlt className="me-2" size={18} />
                    <span className="">Clients</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>

              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "event-logs" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("event-logs")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <BsFillCalendar2EventFill size={18} className="me-2" />

                    <span className="">Event Logs</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "ai-event-logs" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("ai-event-logs")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <BsFillCalendar2EventFill size={18} className="me-2" />

                    <span className="">AI Agent</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "certificate-requests" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("certificate-requests")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <PiCertificateFill size={22} className="me-2" />

                    <span className="">Certificate Requests</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>

              <Dropdown drop="end" className="font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "consent-sharing" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("consent-sharing")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <ConsentSharingIcon
                      fillColor={
                        activeItem === "consent-sharing"
                          ? "#ffffff"
                          : "#000000"
                      }
                    />
                    <span className="">Consent Sharing</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
            </>
          )}
          {isClient && (
            <>
              {/* <Dropdown drop="end" className="font-14 text-start ">
                <Dropdown.Item
                  // href="/dashboard"
                  className={`menu-item ${activeItem === "/dashboard" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/dashboard")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <DashboardIcon
                      fillColor={
                        activeItem === "/dashboard" ? "#ffffff" : "#000000"
                      }
                    />
                    <span className="text-nowrap">Dashboard</span>
                  </div>
                </Dropdown.Item>
              </Dropdown> */}

              <Dropdown drop="end" className="font-14 text-start ">
                <Dropdown.Item
                  // href="/dashboard"
                  className={`menu-item ${activeItem === "/dashboard" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/dashboard")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <DashboardIcon
                      fillColor={
                        activeItem === "/dashboard" ? "#ffffff" : "#000000"
                      }
                    />
                    <span className="text-nowrap">Dashboard</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>

              <Dropdown drop="end" className="font-14 text-start">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/company-details" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/company-details")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <CompanyDetailsIcon
                      fillColor={
                        activeItem === "/company-details"
                          ? "#ffffff"
                          : "#000000"
                      }
                    />
                    <span className="text-nowrap">Company Info</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
              <Dropdown drop="end" className="font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/account-details" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/account-details")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <AccountDetailsIcon
                      fillColor={
                        activeItem === "/account-details"
                          ? "#ffffff"
                          : "#000000"
                      }
                    />
                    <span className="text-nowrap">Account Details</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>

              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/consent-management" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/consent-management")}
                >
                  <div className="d-flex align-content-center justify-content-centert">
                    <ConsentManagmentIcon
                      fillColor={
                        activeItem === "/consent-management"
                          ? "#ffffff"
                          : "#000000"
                      }
                    />
                    <span className="">Consent Management</span>
                    {/* </a> */}
                  </div>
                </Dropdown.Item>
              </Dropdown>
              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/certificate-requested" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/certificate-requested")}
                >
                  <div className="d-flex align-content-center justify-content-centert">
                    <ConsentManagmentIcon
                      fillColor={
                        activeItem === "/certificate-requested"
                          ? "#ffffff"
                          : "#000000"
                      }
                    />
                    <span className="">Request Certificates</span>
                    {/* </a> */}
                  </div>
                </Dropdown.Item>
              </Dropdown>
              {localStorage.getItem("contract_type") !== "SELF SERVICE" &&
                <Dropdown drop="end" className="font-14">
                  <Dropdown.Item
                    className={`menu-item ${activeItem === "/consent-sharing" ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("/consent-sharing")}
                  >
                    <div className="d-flex align-content-center justify-content-center">
                      <ConsentSharingIcon
                        fillColor={
                          activeItem === "/consent-sharing"
                            ? "#ffffff"
                            : "#000000"
                        }
                      />
                      <span className="">Consent Sharing</span>
                    </div>
                  </Dropdown.Item>
                </Dropdown>}
              {/* <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/revocation-management" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/revocation-management")}
                >
                  <div className="d-flex align-content-center justify-content-centert">
                    <SiGoogletagmanager size={18} className="me-1" /><span>Revocation Management</span>
                  </div>
                </Dropdown.Item>
              </Dropdown> */}
              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/event-logs" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/event-logs")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <EventIcons
                      fillColor={
                        activeItem === "/event-logs" ? "#ffffff" : "#000000"
                      }
                    />
                    <span className="">Event Logs</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
              {/* 
              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/ai-event-logs" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/ai-event-logs")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <EventIcons
                      fillColor={
                        activeItem === "/ai-event-logs" ? "#ffffff" : "#000000"
                      }
                    />
                    <span className="">AI Agent</span>
                  </div>
                </Dropdown.Item>
              </Dropdown> */}
              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/ai-agent-new" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/ai-agent-new")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    <EventIcons
                      fillColor={
                        activeItem === "/ai-agent-new" ? "#ffffff" : "#000000"
                      }
                    />
                    <span className="">AI Agent NEW</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
              <Dropdown drop="end" className=" font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/integration" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/integration")}
                >
                  <div className="d-flex align-content-center justify-content-center">

                    <GrIntegration
                      size={18} className="me-1" />

                    <span className="">Integrations</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>

              <Dropdown drop="end" className="font-14">
                <Dropdown.Item
                  className={`menu-item ${activeItem === "/support" ? "active" : ""
                    }`}
                  onClick={() => handleItemClick("/support")}
                >
                  <div className="d-flex align-content-center justify-content-center">
                    {/* <EventIcons
                      fillColor={
                        activeItem === "/support" ? "#ffffff" : "#000000"
                      }
                    /> */}
                    <TbPhoneCall size={18} className="me-1" />

                    <span className="">Contact Us</span>
                  </div>
                </Dropdown.Item>
              </Dropdown>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default VerticalMenu;
